import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';

const ATTIVA_LOGO = "data:image/png;base64,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";

export default function Login() {
  const [email, setEmail]   = useState('');
  const [senha, setSenha]   = useState('');
  const [erro, setErro]     = useState('');
  const [loading, setLoading] = useState(false);
  const [mounted, setMounted] = useState(false);
  const { login } = useAuth();
  const navigate  = useNavigate();

  useEffect(() => {
    setTimeout(() => setMounted(true), 50);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setLoading(true);
    try {
      const res = await api.post('/auth/login', { email, senha });
      login(res.data.token, res.data.usuario);
      navigate(
        res.data.usuario.perfil === 'supervisor' || res.data.usuario.perfil === 'administrador'
          ? '/equipe' : '/dashboard'
      );
    } catch (err) {
      setErro('Email ou senha inválidos');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.root}>
      {/* Barra gradiente topo */}
      <div style={s.topBar}/>

      {/* Fundo com elementos geométricos */}
      <div style={s.bgDecor}>
        <div style={{...s.orb, width:500, height:500, top:-200, left:-150, background:'radial-gradient(circle, #F0702015 0%, transparent 70%)'}}/>
        <div style={{...s.orb, width:400, height:400, bottom:-100, right:-100, background:'radial-gradient(circle, #1E6DB520 0%, transparent 70%)'}}/>
        <div style={{...s.orb, width:300, height:300, top:'40%', right:'10%', background:'radial-gradient(circle, #29B6D810 0%, transparent 70%)'}}/>
        {/* Grid de pontos decorativo */}
        <svg style={s.dotGrid} viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg">
          {Array.from({length:10}, (_,r) => Array.from({length:10}, (_,c) => (
            <circle key={`${r}-${c}`} cx={c*44+2} cy={r*44+2} r="1.5" fill="#F07020" opacity="0.15"/>
          )))}
        </svg>
      </div>

      {/* Card principal */}
      <div style={{
        ...s.card,
        opacity: mounted ? 1 : 0,
        transform: mounted ? 'translateY(0)' : 'translateY(24px)',
        transition: 'opacity 0.6s ease, transform 0.6s ease',
      }}>
        {/* Header com logo */}
        <div style={s.header}>
          <div style={s.logoWrap}>
            <img src={ATTIVA_LOGO} alt="Attiva Pagamentos" style={{height:80, width:'auto'}}/>
          </div>
          <div style={s.wordmark}>
            <span style={s.wordmarkAttiva}>ATTIVA</span>
            <span style={s.wordmarkSub}>PAGAMENTOS S.A.</span>
          </div>
          <div style={s.divider}/>
          <p style={s.appLabel}>Dashboard Grupo Attiva</p>
        </div>

        {/* Formulário */}
        <form onSubmit={handleSubmit} style={s.form}>
          <div style={s.field}>
            <label style={s.label}>Email</label>
            <input
              style={s.input}
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="seu@email.com"
              required
              onFocus={e => e.target.style.borderColor = '#F07020'}
              onBlur={e  => e.target.style.borderColor = '#1A2740'}
            />
          </div>

          <div style={s.field}>
            <label style={s.label}>Senha</label>
            <input
              style={s.input}
              type="password"
              value={senha}
              onChange={e => setSenha(e.target.value)}
              placeholder="••••••••"
              required
              onFocus={e => e.target.style.borderColor = '#F07020'}
              onBlur={e  => e.target.style.borderColor = '#1A2740'}
            />
          </div>

          {erro && (
            <div style={s.erroBox}>
              <span style={{fontSize:13}}>⚠</span>
              <span>{erro}</span>
            </div>
          )}

          <button
            style={{
              ...s.btn,
              opacity: loading ? 0.75 : 1,
              transform: loading ? 'scale(0.98)' : 'scale(1)',
            }}
            type="submit"
            disabled={loading}
          >
            {loading ? (
              <span style={{display:'flex',alignItems:'center',gap:8,justifyContent:'center'}}>
                <span style={s.spinner}/>
                Entrando...
              </span>
            ) : 'Entrar'}
          </button>
        </form>

        {/* Rodapé */}
        <p style={s.footer}>© {new Date().getFullYear()} Attiva Pagamentos S.A.</p>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;600;700&display=swap');
        * { box-sizing: border-box; }
        input::placeholder { color: #334155; }
        @keyframes spin { to { transform: rotate(360deg); } }
        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:.5} }
      `}</style>
    </div>
  );
}

const s = {
  root: {
    minHeight: '100vh',
    background: '#0A0F1A',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: "'Outfit', sans-serif",
    position: 'relative',
    overflow: 'hidden',
    padding: 20,
  },
  topBar: {
    position: 'fixed',
    top: 0, left: 0, right: 0,
    height: 3,
    background: 'linear-gradient(90deg, #F07020, #29B6D8, #1E6DB5)',
    zIndex: 100,
  },
  bgDecor: {
    position: 'absolute',
    inset: 0,
    pointerEvents: 'none',
    overflow: 'hidden',
  },
  orb: {
    position: 'absolute',
    borderRadius: '50%',
    filter: 'blur(40px)',
  },
  dotGrid: {
    position: 'absolute',
    bottom: 40,
    left: 40,
    width: 200,
    height: 200,
    opacity: 0.6,
  },
  card: {
    background: 'linear-gradient(145deg, #0E1826, #0A1220)',
    border: '1px solid #1A2740',
    borderRadius: 20,
    padding: '40px 36px',
    width: '100%',
    maxWidth: 420,
    boxShadow: '0 40px 80px rgba(0,0,0,0.6), 0 0 0 1px rgba(240,112,32,0.08)',
    position: 'relative',
    zIndex: 10,
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 32,
  },
  logoWrap: {
    marginBottom: 16,
    filter: 'drop-shadow(0 8px 24px rgba(240,112,32,0.3))',
  },
  wordmark: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2,
  },
  wordmarkAttiva: {
    color: '#F1F5F9',
    fontSize: 28,
    fontWeight: 700,
    letterSpacing: '0.25em',
    fontFamily: "'Outfit', sans-serif",
    lineHeight: 1,
  },
  wordmarkSub: {
    color: '#64748B',
    fontSize: 10,
    fontWeight: 400,
    letterSpacing: '0.3em',
    textTransform: 'uppercase',
  },
  divider: {
    width: 40,
    height: 2,
    background: 'linear-gradient(90deg, #F07020, #29B6D8)',
    borderRadius: 2,
    margin: '16px 0 12px',
  },
  appLabel: {
    color: '#475569',
    fontSize: 12,
    fontWeight: 400,
    letterSpacing: '0.05em',
    margin: 0,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 18,
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: 7,
  },
  label: {
    color: '#94A3B8',
    fontSize: 12,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
  },
  input: {
    background: '#060C16',
    border: '1px solid #1A2740',
    borderRadius: 10,
    padding: '13px 16px',
    color: '#F1F5F9',
    fontSize: 14,
    fontFamily: "'Outfit', sans-serif",
    outline: 'none',
    transition: 'border-color 0.2s',
    width: '100%',
  },
  erroBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    background: '#EF444415',
    border: '1px solid #EF444440',
    borderRadius: 8,
    padding: '10px 14px',
    color: '#EF4444',
    fontSize: 13,
  },
  btn: {
    background: 'linear-gradient(135deg, #F07020, #C85A10)',
    color: '#fff',
    border: 'none',
    borderRadius: 10,
    padding: '14px',
    fontSize: 15,
    fontWeight: 600,
    fontFamily: "'Outfit', sans-serif",
    cursor: 'pointer',
    marginTop: 4,
    letterSpacing: '0.04em',
    transition: 'opacity 0.2s, transform 0.2s, box-shadow 0.2s',
    boxShadow: '0 8px 24px rgba(240,112,32,0.35)',
    width: '100%',
  },
  spinner: {
    display: 'inline-block',
    width: 14,
    height: 14,
    border: '2px solid rgba(255,255,255,0.3)',
    borderTop: '2px solid #fff',
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite',
  },
  footer: {
    color: '#1E2D40',
    fontSize: 11,
    textAlign: 'center',
    marginTop: 28,
    marginBottom: 0,
    letterSpacing: '0.05em',
  },
};
